import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Icon, Button } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ActiveSelect } from "../inputs";
import SystemCodeCategorySelect from "./SystemCodeCategorySelect";
import SystemCodeCodeNameSelect from "./SystemCodeCodeNameSelect";

function SystemCodeFilters({ filters, onChange, resetFilters }) {
  const { Active, Category, CodeName } = filters;
  return (
    <Field kind="group">
      <Control>
        <ActiveSelect
          label="Active"
          name="Active"
          value={Active}
          onChange={onChange}
        />
      </Control>
      <Control>
        <SystemCodeCategorySelect
          label="Category"
          name="Category"
          value={Category}
          where={{ CodeName }}
          onChange={onChange}
        />
      </Control>
      <Control>
        <SystemCodeCodeNameSelect
          label="Code Name"
          name="CodeName"
          value={CodeName}
          where={{ Category }}
          onChange={onChange}
        />
      </Control>
      <Control>
        <Button onClick={resetFilters}>
          <Icon>
            <FontAwesomeIcon icon="times" />
          </Icon>
          <span>Reset Filters</span>
        </Button>
      </Control>
    </Field>
  );
}
SystemCodeFilters.propTypes = {
  filters: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  resetFilters: PropTypes.func
};
export default SystemCodeFilters;
